import React from "react";

const ProfileSectionCard = ({
  id,
  eyebrow,
  title,
  icon: Icon,
  trailing,
  children,
  className = "",
}) => (
  <section id={id} className={`prof-section ${className}`.trim()}>
    <header className="prof-section-head">
      <div className="prof-section-head-main">
        {Icon ? (
          <span className="prof-section-icon" aria-hidden>
            <Icon size={14} />
          </span>
        ) : null}
        <div>
          {eyebrow ? <p className="prof-section-eyebrow">{eyebrow}</p> : null}
          <h2>{title}</h2>
        </div>
      </div>
      {trailing ? <div className="prof-section-trailing">{trailing}</div> : null}
    </header>
    <div className="prof-section-body">{children}</div>
  </section>
);

export default ProfileSectionCard;
